module.exports = __webpack_public_path__ + "img/charge_status_3.3f58f755.png";